export type RestPeriodRow = {
  id: string;
  isCancelled: boolean;
  contractPackageId: string;
  contractPlanName?: string | null;
  personId: string;
  restPeriodTemplateId?: string | null;
  restPeriodTemplateName?: string | null;
  restPeriodReasonId?: string | null;
  restPeriodReasonName?: string | null;
  monthlyFee?: number | null;
  feeAmountUnit?: number | null;
  feeCycleUnit?: number | null;
  feeCycleValue?: number | null;
  weeksCount?: number | null;
  proportionalCalculationMethod?: number | null;
  extendsContract: boolean;
  continuePayment: boolean;
  appendFreeToEnd: boolean;
  billingScheduleMode: number;
  allowCheckInDuringRestPeriod: boolean;
  startDate: string;
  endDate: string;
  note?: string | null;
  createdAt: string;
  confirmationLetterSentAt?: string | null;
  confirmationDocumentId?: string | null;
  confirmationStatus: "sent" | "open" | "unknown";
  /** Eingang des Anliegens (Theke, Telefon, E-Mail, App, Brief); leer bei älteren Einträgen. */
  requestChannel?: number | null;
};

/**
 * Rohzeilen der Ruhezeiten-Antwort. Die Felder tragen bereits die Zieltypen — die Abbildung darunter
 * setzt nur Vorgaben und wandelt Ids in Text. Deshalb `Partial<RestPeriodRow>` statt eines losen
 * Record-Typs: so bleibt jedes Feld geprüft.
 */
export type RestPeriodApiRow = Partial<RestPeriodRow>;

export function normalizeRestPeriodRows(list: RestPeriodApiRow[]): RestPeriodRow[] {
  return (list || []).map((x) => ({
    id: String(x.id),
    isCancelled: x.isCancelled === true,
    contractPackageId: String(x.contractPackageId),
    contractPlanName: x.contractPlanName ?? null,
    personId: String(x.personId),
    restPeriodTemplateId: x.restPeriodTemplateId ? String(x.restPeriodTemplateId) : null,
    restPeriodTemplateName: x.restPeriodTemplateName ?? null,
    restPeriodReasonId: x.restPeriodReasonId ? String(x.restPeriodReasonId) : null,
    restPeriodReasonName: x.restPeriodReasonName ?? null,
    monthlyFee: x.monthlyFee ?? null,
    feeAmountUnit: x.feeAmountUnit ?? null,
    feeCycleUnit: x.feeCycleUnit ?? null,
    feeCycleValue: x.feeCycleValue ?? null,
    weeksCount: x.weeksCount ?? null,
    proportionalCalculationMethod: x.proportionalCalculationMethod ?? null,
    extendsContract: x.extendsContract !== false,
    continuePayment: x.continuePayment === true,
    appendFreeToEnd: x.appendFreeToEnd === true,
    billingScheduleMode: x.billingScheduleMode ?? 0,
    allowCheckInDuringRestPeriod: x.allowCheckInDuringRestPeriod === true,
    startDate: String(x.startDate || ""),
    endDate: String(x.endDate || ""),
    note: x.note ?? null,
    requestChannel: typeof x.requestChannel === "number" ? x.requestChannel : null,
    createdAt: String(x.createdAt || ""),
    confirmationLetterSentAt: x.confirmationLetterSentAt ? String(x.confirmationLetterSentAt) : null,
    confirmationDocumentId: x.confirmationDocumentId ? String(x.confirmationDocumentId) : null,
    confirmationStatus: x.confirmationStatus === "unknown"
      ? "unknown"
      : x.confirmationLetterSentAt || x.confirmationStatus === "sent"
        ? "sent"
        : "open"
  }));
}

